export const EnvioAbsentismoRechazo = Object.freeze({
    INDIVIDUAL: "INDIVIDUAL",
    MASIVA: "MASIVA",    
});
